<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import Modal, { ModalSize } from '../Modal.vue';
    import PanelButton from '../PanelButton.vue';
    import { MessageSquareIcon, PlusIcon } from '@lucide/vue';

    interface Props {
        show: boolean;
    }

    defineProps<Props>();

    defineEmits<{
        (e: 'close'): void;
        (e: 'addWidget', value: 'library' | 'new' | 'ask-me'): void;
    }>();
</script>
<template>
    <Modal :show="show" :size="ModalSize.Medium" @close="$emit('close')">
        <h1 class="text-3xl font-semibold">
            {{ __('dashboard-add-widget') }}
        </h1>
        <p class="text-base mb-8">
            {{ __('add-widget-from-description') }}
        </p>
        <div class="flex flex-row gap-4 flex-wrap">
            <!-- TODO: Hide library button -->
            <!-- <PanelButton
                :title="__('add-from-library-title')"
                :description="__('add-from-library-description')"
                icon="bookmark.svg"
                @click="$emit('addWidget', 'library')"
            /> -->
            <PanelButton
                class="bg-white border-gray-lightest text-primary-plum"
                :title="__('create-new-widget-title')"
                :description="__('create-new-widget-description')"
                @click="$emit('addWidget', 'new')"
            >
                <template #icon><PlusIcon /></template>
            </PanelButton>
            <PanelButton
                class="bg-white border-primary-raspberry text-primary-beet"
                :title="__('create-with-ask-me-title')"
                :description="__('create-with-ask-me-description')"
                @click="$emit('addWidget', 'ask-me')"
            >
                <template #icon><MessageSquareIcon /></template>
            </PanelButton>
        </div>
    </Modal>
</template>
